// extracted by mini-css-extract-plugin
export default {"Menu":"EditMenuStyles_Menu__0iSCz","MenuItem":"EditMenuStyles_MenuItem__p6mX4"};